import * as api from '../api/global';
import { makeApiActionCreatorV3 } from '@actions/utils';

export const START = 'START';
export const SUCCESS = 'SUCCESS';
export const ERROR = 'ERROR';

const prefix = 'APPRAISAL-ADMIN';

export function createRequestTypes(base) {
  return [START, SUCCESS, ERROR].reduce((acc, type) => {
    acc[type] = `${base}_${type}`;
    return acc;
  }, {});
}

export const PREFERENCE_FETCH_START = 'APPRAISAL-ADMIN/PREFERENCE_FETCH_START';
export const PREFERENCE_FETCH_SUCCESS =
  'APPRAISAL-ADMIN/PREFERENCE_FETCH_SUCCESS';
export const PREFERENCE_FETCH_ERROR = 'APPRAISAL-ADMIN/PREFERENCE_FETCH_ERROR';

export const PREFERENCE_PERSIST_START =
  'APPRAISAL-ADMIN/PREFERENCE_PERSIST_START';
export const PREFERENCE_PERSIST_SUCCESS =
  'APPRAISAL-ADMIN/PREFERENCE_PERSIST_SUCCESS';
export const PREFERENCE_PERSIST_ERROR =
  'APPRAISAL-ADMIN/PREFERENCE_PERSIST_ERROR';

export const fetchPreference = makeApiActionCreatorV3(
  api.fetchPreference,
  PREFERENCE_FETCH_START,
  PREFERENCE_FETCH_SUCCESS,
  PREFERENCE_FETCH_ERROR,
);
export const persistPreference = makeApiActionCreatorV3(
  api.persistPreference,
  PREFERENCE_PERSIST_START,
  PREFERENCE_PERSIST_SUCCESS,
  PREFERENCE_PERSIST_ERROR,
);

export const FETCH_YEAR_EDITABL = 'APPRAISAL-ADMIN/FETCH_YEAR_EDITABL';

export const fetchYearEditable = makeApiActionCreatorV3(
  api.fetchYearEditable,
  FETCH_YEAR_EDITABL,
  FETCH_YEAR_EDITABL,
  FETCH_YEAR_EDITABL,
);

export const FETCH_ELECTRONIC_DELIVERY_REQUEST_CONFIG = createRequestTypes(
  `${prefix}/FETCH_ELECTRONIC_DELIVERY_REQUEST_CONFIG`,
);

export const fetchElectronicDeliveryRequestsConfig = makeApiActionCreatorV3(
  api.fetchElectronicDeliveryRequestsConfig,
  FETCH_ELECTRONIC_DELIVERY_REQUEST_CONFIG[START],
  FETCH_ELECTRONIC_DELIVERY_REQUEST_CONFIG[SUCCESS],
  FETCH_ELECTRONIC_DELIVERY_REQUEST_CONFIG[ERROR],
);

export const UPDATE_ELECTRONIC_DELIVERY_REQUEST_CONFIG = createRequestTypes(
  `${prefix}/UPDATE_ELECTRONIC_DELIVERY_REQUEST_CONFIG`,
);

export const updateElectronicDeliveryRequestsConfig = makeApiActionCreatorV3(
  api.updateElectronicDeliveryRequestsConfig,
  UPDATE_ELECTRONIC_DELIVERY_REQUEST_CONFIG[START],
  UPDATE_ELECTRONIC_DELIVERY_REQUEST_CONFIG[SUCCESS],
  UPDATE_ELECTRONIC_DELIVERY_REQUEST_CONFIG[ERROR],
);

export const FETCH_ELECTRONIC_DELIVERY_REQUEST_STATUS_CONFIGS =
  createRequestTypes(
    `${prefix}/FETCH_ELECTRONIC_DELIVERY_REQUEST_STATUS_CONFIGS`,
  );

export const fetchElectronicDeliveryRequestsStatusConfigs =
  makeApiActionCreatorV3(
    api.fetchElectronicDeliveryRequestsStatusConfigs,
    FETCH_ELECTRONIC_DELIVERY_REQUEST_STATUS_CONFIGS[START],
    FETCH_ELECTRONIC_DELIVERY_REQUEST_STATUS_CONFIGS[SUCCESS],
    FETCH_ELECTRONIC_DELIVERY_REQUEST_STATUS_CONFIGS[ERROR],
  );

export const INSERT_ELECTRONIC_DELIVERY_REQUEST_STATUS_CONFIG =
  createRequestTypes(
    `${prefix}/INSERT_ELECTRONIC_DELIVERY_REQUEST_STATUS_CONFIG`,
  );

export const insertElectronicDeliveryRequestsStatusConfig =
  makeApiActionCreatorV3(
    api.insertElectronicDeliveryRequestsStatusConfig,
    INSERT_ELECTRONIC_DELIVERY_REQUEST_STATUS_CONFIG[START],
    INSERT_ELECTRONIC_DELIVERY_REQUEST_STATUS_CONFIG[SUCCESS],
    INSERT_ELECTRONIC_DELIVERY_REQUEST_STATUS_CONFIG[ERROR],
  );

export const FETCH_ELECTRONIC_DELIVERY_REQUEST_STATUS_CONFIG =
  createRequestTypes(
    `${prefix}/FETCH_ELECTRONIC_DELIVERY_REQUEST_STATUS_CONFIG`,
  );

export const fetchElectronicDeliveryRequestsStatusConfig =
  makeApiActionCreatorV3(
    api.fetchElectronicDeliveryRequestsStatusConfig,
    FETCH_ELECTRONIC_DELIVERY_REQUEST_STATUS_CONFIG[START],
    FETCH_ELECTRONIC_DELIVERY_REQUEST_STATUS_CONFIG[SUCCESS],
    FETCH_ELECTRONIC_DELIVERY_REQUEST_STATUS_CONFIG[ERROR],
  );

export const DELETE_ELECTRONIC_DELIVERY_REQUEST_STATUS_CONFIG =
  createRequestTypes(
    `${prefix}/DELETE_ELECTRONIC_DELIVERY_REQUEST_STATUS_CONFIG`,
  );

export const deleteElectronicDeliveryRequestsStatusConfig =
  makeApiActionCreatorV3(
    api.deleteElectronicDeliveryRequestsStatusConfig,
    DELETE_ELECTRONIC_DELIVERY_REQUEST_STATUS_CONFIG[START],
    DELETE_ELECTRONIC_DELIVERY_REQUEST_STATUS_CONFIG[SUCCESS],
    DELETE_ELECTRONIC_DELIVERY_REQUEST_STATUS_CONFIG[ERROR],
  );

export const UPDATE_ELECTRONIC_DELIVERY_REQUEST_STATUS_CONFIG =
  createRequestTypes(
    `${prefix}/UPDATE_ELECTRONIC_DELIVERY_REQUEST_STATUS_CONFIG`,
  );

export const udpateElectronicDeliveryRequestsStatusConfig =
  makeApiActionCreatorV3(
    api.udpateElectronicDeliveryRequestsStatusConfig,
    UPDATE_ELECTRONIC_DELIVERY_REQUEST_STATUS_CONFIG[START],
    UPDATE_ELECTRONIC_DELIVERY_REQUEST_STATUS_CONFIG[SUCCESS],
    UPDATE_ELECTRONIC_DELIVERY_REQUEST_STATUS_CONFIG[ERROR],
  );

export const FETCH_ELECTRONIC_DELIVERY_REQUEST_STATUS_STATES =
  createRequestTypes(
    `${prefix}/FETCH_ELECTRONIC_DELIVERY_REQUEST_STATUS_STATES`,
  );

export const fetchElectronicDeliveryRequestsStatusStates =
  makeApiActionCreatorV3(
    api.fetchElectronicDeliveryRequestsStatusStates,
    FETCH_ELECTRONIC_DELIVERY_REQUEST_STATUS_STATES[START],
    FETCH_ELECTRONIC_DELIVERY_REQUEST_STATUS_STATES[SUCCESS],
    FETCH_ELECTRONIC_DELIVERY_REQUEST_STATUS_STATES[ERROR],
  );

export const SET_ELECTRONIC_DELIVERY_REQUEST_STATUS_DEFAULT =
  createRequestTypes(
    `${prefix}/SET_ELECTRONIC_DELIVERY_REQUEST_STATUS_DEFAULT`,
  );

export const setElectronicDeliveryRequestsStatusDefault =
  makeApiActionCreatorV3(
    api.setElectronicDeliveryRequestsStatusDefault,
    SET_ELECTRONIC_DELIVERY_REQUEST_STATUS_DEFAULT[START],
    SET_ELECTRONIC_DELIVERY_REQUEST_STATUS_DEFAULT[SUCCESS],
    SET_ELECTRONIC_DELIVERY_REQUEST_STATUS_DEFAULT[ERROR],
  );

export const FETCH_PORTAL_SIGN_UP_RUN_PENDING = createRequestTypes(
  `${prefix}/FETCH_PORTAL_SIGN_UP_RUN_PENDING`,
);

export const fetchPortalSignUpRunPending = makeApiActionCreatorV3(
  api.fetchPortalSignUpRunPending,
  FETCH_PORTAL_SIGN_UP_RUN_PENDING[START],
  FETCH_PORTAL_SIGN_UP_RUN_PENDING[SUCCESS],
  FETCH_PORTAL_SIGN_UP_RUN_PENDING[ERROR],
);

export const FETCH_PORTAL_SIGN_UP_EMAIL_CONFIG = createRequestTypes(
  `${prefix}/FETCH_PORTAL_SIGN_UP_EMAIL_CONFIG`,
);

export const fetchPortalSignUpEmailConfig = makeApiActionCreatorV3(
  api.fetchPortalSignUpEmailConfig,
  FETCH_PORTAL_SIGN_UP_EMAIL_CONFIG[START],
  FETCH_PORTAL_SIGN_UP_EMAIL_CONFIG[SUCCESS],
  FETCH_PORTAL_SIGN_UP_EMAIL_CONFIG[ERROR],
);

export const UPDATE_PORTAL_SIGN_UP_EMAIL_CONFIG = createRequestTypes(
  `${prefix}/UPDATE_PORTAL_SIGN_UP_EMAIL_CONFIG`,
);

export const updatePortalSignUpEmailConfig = makeApiActionCreatorV3(
  api.updatePortalSignUpEmailConfig,
  UPDATE_PORTAL_SIGN_UP_EMAIL_CONFIG[START],
  UPDATE_PORTAL_SIGN_UP_EMAIL_CONFIG[SUCCESS],
  UPDATE_PORTAL_SIGN_UP_EMAIL_CONFIG[ERROR],
);

export const FETCH_PORTAL_NOTIFICATION_EMAIL_CONFIG = createRequestTypes(
  `${prefix}/FETCH_PORTAL_NOTIFICATION_EMAIL_CONFIG`,
);

export const fetchPortalNotificationEmailConfig = makeApiActionCreatorV3(
  api.fetchPortalNotificationEmailConfig,
  FETCH_PORTAL_NOTIFICATION_EMAIL_CONFIG[START],
  FETCH_PORTAL_NOTIFICATION_EMAIL_CONFIG[SUCCESS],
  FETCH_PORTAL_NOTIFICATION_EMAIL_CONFIG[ERROR],
);

export const UPDATE_PORTAL_NOTIFICATION_EMAIL_CONFIG = createRequestTypes(
  `${prefix}/UPDATE_PORTAL_NOTIFICATION_EMAIL_CONFIG`,
);

export const updatePortalNotificationEmailConfig = makeApiActionCreatorV3(
  api.updatePortalNotificationEmailConfig,
  UPDATE_PORTAL_NOTIFICATION_EMAIL_CONFIG[START],
  UPDATE_PORTAL_NOTIFICATION_EMAIL_CONFIG[SUCCESS],
  UPDATE_PORTAL_NOTIFICATION_EMAIL_CONFIG[ERROR],
);

export const FETCH_PORTAL_EMAIL_PREVIEW = createRequestTypes(
  `${prefix}/FETCH_PORTAL_EMAIL_PREVIEW`,
);

export const fetchPortalEmailPreview = makeApiActionCreatorV3(
  api.fetchPortalEmailPreview,
  FETCH_PORTAL_EMAIL_PREVIEW[START],
  FETCH_PORTAL_EMAIL_PREVIEW[SUCCESS],
  FETCH_PORTAL_EMAIL_PREVIEW[ERROR],
);

export const CREATE_PORTAL_SIGN_UP_NOTIFICATION_RUN = createRequestTypes(
  `${prefix}/CREATE_PORTAL_SIGN_UP_NOTIFICATION_RUN`,
);

export const createPortalSignUpNotificationRun = makeApiActionCreatorV3(
  api.createPortalSignUpNotificationRun,
  CREATE_PORTAL_SIGN_UP_NOTIFICATION_RUN[START],
  CREATE_PORTAL_SIGN_UP_NOTIFICATION_RUN[SUCCESS],
  CREATE_PORTAL_SIGN_UP_NOTIFICATION_RUN[ERROR],
);

export const CREATE_PORTAL_SIGN_UP_NOTIFICATION_RUN_SINGLE = createRequestTypes(
  `${prefix}/CREATE_PORTAL_SIGN_UP_NOTIFICATION_RUN_SINGLE`,
);

export const createPortalSignUpNotificationRunSingle = makeApiActionCreatorV3(
  api.createPortalSignUpNotificationRunSingle,
  CREATE_PORTAL_SIGN_UP_NOTIFICATION_RUN_SINGLE[START],
  CREATE_PORTAL_SIGN_UP_NOTIFICATION_RUN_SINGLE[SUCCESS],
  CREATE_PORTAL_SIGN_UP_NOTIFICATION_RUN_SINGLE[ERROR],
);

export const FETCH_PORTAL_SIGN_UP_NOTIFICATION_RUNS = createRequestTypes(
  `${prefix}/FETCH_PORTAL_SIGN_UP_NOTIFICATION_RUNS`,
);

export const fetchPortalSignUpNotificationRuns = makeApiActionCreatorV3(
  api.fetchPortalSignUpNotificationRuns,
  FETCH_PORTAL_SIGN_UP_NOTIFICATION_RUNS[START],
  FETCH_PORTAL_SIGN_UP_NOTIFICATION_RUNS[SUCCESS],
  FETCH_PORTAL_SIGN_UP_NOTIFICATION_RUNS[ERROR],
);

export const FETCH_PORTAL_SIGN_UP_NOTIFICATION_RUN_RECORDS = createRequestTypes(
  `${prefix}/FETCH_PORTAL_SIGN_UP_NOTIFICATION_RUN_RECORDS`,
);

export const fetchPortalSignUpNotificationRunRecords = makeApiActionCreatorV3(
  api.fetchPortalSignUpNotificationRunRecords,
  FETCH_PORTAL_SIGN_UP_NOTIFICATION_RUN_RECORDS[START],
  FETCH_PORTAL_SIGN_UP_NOTIFICATION_RUN_RECORDS[SUCCESS],
  FETCH_PORTAL_SIGN_UP_NOTIFICATION_RUN_RECORDS[ERROR],
);

export const FETCH_MASS_UPDATE_PROPERTY_JOBS = createRequestTypes(
  `${prefix}/FETCH_MASS_UPDATE_PROPERTY_JOBS`,
);

export const fetchMassUpdatePropertyJobs = makeApiActionCreatorV3(
  api.fetchMassUpdatePropertyJobs,
  FETCH_MASS_UPDATE_PROPERTY_JOBS[START],
  FETCH_MASS_UPDATE_PROPERTY_JOBS[SUCCESS],
  FETCH_MASS_UPDATE_PROPERTY_JOBS[ERROR],
);

export const FETCH_MASS_UPDATE_OTHER_JOBS = createRequestTypes(
  `${prefix}/FETCH_MASS_UPDATE_OTHER_JOBS`,
);

export const fetchMassUpdateOtherJobs = makeApiActionCreatorV3(
  api.fetchMassUpdateOtherJobs,
  FETCH_MASS_UPDATE_OTHER_JOBS[START],
  FETCH_MASS_UPDATE_OTHER_JOBS[SUCCESS],
  FETCH_MASS_UPDATE_OTHER_JOBS[ERROR],
);

export const INSERT_MASS_UPDATE_PROPERTY_JOBS = createRequestTypes(
  `${prefix}/INSERT_MASS_UPDATE_PROPERTY_JOBS`,
);

export const insertMassUpdatePropertyJobs = makeApiActionCreatorV3(
  api.insertMassUpdatePropertyJobs,
  INSERT_MASS_UPDATE_PROPERTY_JOBS[START],
  INSERT_MASS_UPDATE_PROPERTY_JOBS[SUCCESS],
  INSERT_MASS_UPDATE_PROPERTY_JOBS[ERROR],
);

export const INSERT_MASS_UPDATE_OTHER_JOBS = createRequestTypes(
  `${prefix}/INSERT_MASS_UPDATE_OTHER_JOBS`,
);

export const insertMassUpdateOtherJobs = makeApiActionCreatorV3(
  api.insertMassUpdateOtherJobs,
  INSERT_MASS_UPDATE_OTHER_JOBS[START],
  INSERT_MASS_UPDATE_OTHER_JOBS[SUCCESS],
  INSERT_MASS_UPDATE_OTHER_JOBS[ERROR],
);

export const FETCH_MASS_UPDATE_OTHER_JOB_RECORDS = createRequestTypes(
  `${prefix}/FETCH_MASS_UPDATE_OTHER_JOB_RECORDS`,
);

export const fetchMassUpdateOtherJobRecords = makeApiActionCreatorV3(
  api.fetchMassUpdateOtherJobRecords,
  FETCH_MASS_UPDATE_OTHER_JOB_RECORDS[START],
  FETCH_MASS_UPDATE_OTHER_JOB_RECORDS[SUCCESS],
  FETCH_MASS_UPDATE_OTHER_JOB_RECORDS[ERROR],
);

export const MASS_UPDATE_OTHER_VALIDATE_QUERY = createRequestTypes(
  `${prefix}/MASS_UPDATE_OTHER_VALIDATE_QUERY`,
);

export const massUpdateOtherValidateQuery = makeApiActionCreatorV3(
  api.massUpdateOtherValidateQuery,
  MASS_UPDATE_OTHER_VALIDATE_QUERY[START],
  MASS_UPDATE_OTHER_VALIDATE_QUERY[SUCCESS],
  MASS_UPDATE_OTHER_VALIDATE_QUERY[ERROR],
);

export const FETCH_MASS_UPDATE_OTHER_CATEGORY_RUN_TYPES = createRequestTypes(
  `${prefix}/FETCH_MASS_UPDATE_OTHER_CATEGORY_RUN_TYPES`,
);

export const fetchMassUpdateOtherCategoryRunTypes = makeApiActionCreatorV3(
  api.fetchMassUpdateOtherCategoryRunTypes,
  FETCH_MASS_UPDATE_OTHER_CATEGORY_RUN_TYPES[START],
  FETCH_MASS_UPDATE_OTHER_CATEGORY_RUN_TYPES[SUCCESS],
  FETCH_MASS_UPDATE_OTHER_CATEGORY_RUN_TYPES[ERROR],
);

export const UPLOAD_FILES = createRequestTypes(`${prefix}/UPLOAD_FILES`);

export const uploadFiles = makeApiActionCreatorV3(
  api.uploadFiles,
  UPLOAD_FILES[START],
  UPLOAD_FILES[SUCCESS],
  UPLOAD_FILES[ERROR],
);

export const FETCH_MASS_UPDATE_PROPERTY_JOB_PROPERTIES = createRequestTypes(
  `${prefix}/FETCH_MASS_UPDATE_PROPERTY_JOB_PROPERTIES`,
);

export const fetchMassUpdatePropertyJobProperties = makeApiActionCreatorV3(
  api.fetchMassUpdatePropertyJobProperties,
  FETCH_MASS_UPDATE_PROPERTY_JOB_PROPERTIES[START],
  FETCH_MASS_UPDATE_PROPERTY_JOB_PROPERTIES[SUCCESS],
  FETCH_MASS_UPDATE_PROPERTY_JOB_PROPERTIES[ERROR],
);

export const FETCH_PORTAL_NOTIFICATION_RUNS = createRequestTypes(
  `${prefix}/FETCH_PORTAL_NOTIFICATION_RUNS`,
);

export const fetchPortalNotificationRuns = makeApiActionCreatorV3(
  api.fetchPortalNotificationRuns,
  FETCH_PORTAL_NOTIFICATION_RUNS[START],
  FETCH_PORTAL_NOTIFICATION_RUNS[SUCCESS],
  FETCH_PORTAL_NOTIFICATION_RUNS[ERROR],
);

export const FETCH_PENDING_PORTAL_NOTIFICATIONS = createRequestTypes(
  `${prefix}/FETCH_PENDING_PORTAL_NOTIFICATIONS`,
);

export const fetchPendingPortalNotifications = makeApiActionCreatorV3(
  api.fetchPendingPortalNotifications,
  FETCH_PENDING_PORTAL_NOTIFICATIONS[START],
  FETCH_PENDING_PORTAL_NOTIFICATIONS[SUCCESS],
  FETCH_PENDING_PORTAL_NOTIFICATIONS[ERROR],
);

export const FETCH_PORTAL_NOTIFICATION_RUN_RECORDS = createRequestTypes(
  `${prefix}/FETCH_PORTAL_NOTIFICATION_RUN_RECORDS`,
);

export const fetchPortalNotificationRunRecords = makeApiActionCreatorV3(
  api.fetchPortalNotificationRunRecords,
  FETCH_PORTAL_NOTIFICATION_RUN_RECORDS[START],
  FETCH_PORTAL_NOTIFICATION_RUN_RECORDS[SUCCESS],
  FETCH_PORTAL_NOTIFICATION_RUN_RECORDS[ERROR],
);

export const CREATE_PORTAL_NOTIFICATION_RUN = createRequestTypes(
  `${prefix}/CREATE_PORTAL_NOTIFICATION_RUN`,
);

export const createPortalNotificationRun = makeApiActionCreatorV3(
  api.createPortalNotificationRun,
  CREATE_PORTAL_NOTIFICATION_RUN[START],
  CREATE_PORTAL_NOTIFICATION_RUN[SUCCESS],
  CREATE_PORTAL_NOTIFICATION_RUN[ERROR],
);

export const CREATE_NOTIFICATION_RUN_SINGLE = createRequestTypes(
  `${prefix}/CREATE_NOTIFICATION_RUN_SINGLE`,
);

export const createNotificationRunSingle = makeApiActionCreatorV3(
  api.createNotificationRunSingle,
  CREATE_NOTIFICATION_RUN_SINGLE[START],
  CREATE_NOTIFICATION_RUN_SINGLE[SUCCESS],
  CREATE_NOTIFICATION_RUN_SINGLE[ERROR],
);

export const FETCH_PORTAL_NOTIFICATION_AGENT_EMAIL_CONFIG = createRequestTypes(
  `${prefix}/FETCH_PORTAL_NOTIFICATION_AGENT_EMAIL_CONFIG`,
);

export const fetchPortalNotificationAgentEmailConfig = makeApiActionCreatorV3(
  api.fetchPortalNotificationAgentEmailConfig,
  FETCH_PORTAL_NOTIFICATION_AGENT_EMAIL_CONFIG[START],
  FETCH_PORTAL_NOTIFICATION_AGENT_EMAIL_CONFIG[SUCCESS],
  FETCH_PORTAL_NOTIFICATION_AGENT_EMAIL_CONFIG[ERROR],
);

export const UPDATE_PORTAL_NOTIFICATION_AGENT_EMAIL_CONFIG = createRequestTypes(
  `${prefix}/UPDATE_PORTAL_NOTIFICATION_AGENT_EMAIL_CONFIG`,
);

export const updatePortalNotificationAgentEmailConfig = makeApiActionCreatorV3(
  api.updatePortalNotificationAgentEmailConfig,
  UPDATE_PORTAL_NOTIFICATION_AGENT_EMAIL_CONFIG[START],
  UPDATE_PORTAL_NOTIFICATION_AGENT_EMAIL_CONFIG[SUCCESS],
  UPDATE_PORTAL_NOTIFICATION_AGENT_EMAIL_CONFIG[ERROR],
);

export const FETCH_PORTAL_AGENT_EMAIL_PREVIEW = createRequestTypes(
  `${prefix}/FETCH_PORTAL_AGENT_EMAIL_PREVIEW`,
);

export const fetchPortalAgentEmailPreview = makeApiActionCreatorV3(
  api.fetchPortalAgentEmailPreview,
  FETCH_PORTAL_AGENT_EMAIL_PREVIEW[START],
  FETCH_PORTAL_AGENT_EMAIL_PREVIEW[SUCCESS],
  FETCH_PORTAL_AGENT_EMAIL_PREVIEW[ERROR],
);

export const FETCH_PORTAL_NOTIFICATION_PREVIEW_EMAIL = createRequestTypes(
  `${prefix}/FETCH_PORTAL_NOTIFICATION_PREVIEW_EMAIL`,
);

export const fetchPortalNotificationPreviewEmail = makeApiActionCreatorV3(
  api.fetchPortalNotificationPreviewEmail,
  FETCH_PORTAL_NOTIFICATION_PREVIEW_EMAIL[START],
  FETCH_PORTAL_NOTIFICATION_PREVIEW_EMAIL[SUCCESS],
  FETCH_PORTAL_NOTIFICATION_PREVIEW_EMAIL[ERROR],
);

export const FETCH_PENDING_NOTIFICATION_RECORDS = createRequestTypes(
  `${prefix}/FETCH_PENDING_NOTIFICATION_RECORDS`,
);

export const fetchPendingNotificationRecords = makeApiActionCreatorV3(
  api.fetchPendingNotificationRecords,
  FETCH_PENDING_NOTIFICATION_RECORDS[START],
  FETCH_PENDING_NOTIFICATION_RECORDS[SUCCESS],
  FETCH_PENDING_NOTIFICATION_RECORDS[ERROR],
);

export const FETCH_EDR_RUN_DETAILS = createRequestTypes(
  `${prefix}/FETCH_EDR_RUN_DETAILS`,
);

export const fetchEdrRunDetails = makeApiActionCreatorV3(
  api.getEdrRunDetails,
  FETCH_EDR_RUN_DETAILS[START],
  FETCH_EDR_RUN_DETAILS[SUCCESS],
  FETCH_EDR_RUN_DETAILS[ERROR],
);

export const CREATE_EDR_NOTIFICATIONS = createRequestTypes(
  `${prefix}/CREATE_EDR_NOTIFICATIONS`,
);

export const createEdrNotifications = makeApiActionCreatorV3(
  api.createEDRNotificationsForMassFileImportRun,
  CREATE_EDR_NOTIFICATIONS[START],
  CREATE_EDR_NOTIFICATIONS[SUCCESS],
  CREATE_EDR_NOTIFICATIONS[ERROR],
);
